var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_947_10537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8263 9.2195C21.9669 9.07886 22.0458 8.88817 22.0458 8.68934C22.0458 8.49051 21.9669 8.29982 21.8263 8.15918L16.1395 2.4695C15.9988 2.32895 15.8081 2.25 15.6093 2.25C15.4105 2.25 15.2198 2.32895 15.0792 2.4695L9.70728 7.85637C9.70728 7.85637 7.10572 6.55606 4.32697 8.79856C4.24457 8.86452 4.17702 8.94712 4.12874 9.04098C4.08045 9.13483 4.05252 9.23782 4.04677 9.34321C4.04102 9.4486 4.05757 9.55402 4.09536 9.65257C4.13314 9.75112 4.1913 9.84059 4.26603 9.91512L14.3817 20.0298C14.4574 20.105 14.5484 20.1632 14.6484 20.2004C14.7484 20.2377 14.8553 20.2531 14.9618 20.2457C15.0683 20.2384 15.172 20.2084 15.2659 20.1577C15.3599 20.1071 15.442 20.0369 15.5067 19.952C16.2932 18.9057 17.5288 16.7561 16.4545 14.6082L21.8263 9.2195Z",
    stroke: "#667F93",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32284 14.9727L4.79565 19.4998",
    stroke: "#667F93",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_947_10537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin-icon.24ccb8193d5fa067493a2b0ca62b3263.svg";